import Entity from "@/model/entity";
import Option from "@/model/option";
import Allergen from "@/model/allergen";

/**
 * Restaurant information.
 *
 * Object representation for a Restaurant document from the database.
 */
class Restaurant extends Entity {
  constructor({
    id,
    name,
    mapImage,
    banner,
    logo,
    menu,
    options,
    allergens,
    mailSubscription,
    customerTheme,
    startStep,
    user,
    acceptOrdersAuto,
    colors,
    cash,
    card,
    gpay,
    waiter,
    qrLogo,
    locale
  } = {}) {
    super({ id: id });
    this.name = name;
    this.mapImage = mapImage;
    this.banner = banner;
    this.logo = logo;
    this.menu = menu;
    this.options = options;
    this.allergens = allergens;
    this.mailSubscription = mailSubscription;
    this.customerTheme = customerTheme;
    this.startStep = startStep;
    this.user = user;
    this.acceptOrdersAuto = acceptOrdersAuto;
    this.colors = colors;
    this.cash = cash;
    this.card = card;
    this.gpay = gpay;
    this.waiter = waiter;
    this.qrLogo = qrLogo;
    this.locale = locale;
  }

  /**
   * @returns A plain JS object containing the fields as they will be saved to the
   * database.
   */
  _toMap() {
    return {
      id: this.id,
      name: this.name,
      mapImage: this.mapImage,
      banner: this.banner,
      logo: this.logo,
      menu: this.menu,
      options: this.options ? this.options.map(option => option.toMap()) : [],
      allergens: this.allergens
        ? this.allergens.map(allergen => allergen.toMap())
        : [],
      mailSubscription: this.mailSubscription,
      customerTheme: this.customerTheme,
      startStep: this.startStep,
      user: this.user,
      acceptOrdersAuto: this.acceptOrdersAuto,
      colors: this.colors,
      cash: this.cash,
      card: this.card,
      gpay: this.gpay,
      waiter: this.waiter,
      qrLogo: this.qrLogo,
      locale: this.locale
    };
  }

  /**
   *
   * @param {*} snapData Restaurant document data as a plain JS object
   * snapshot represented by this `Restaurant`.
   *
   * @returns {Restaurant} A new instance created from the provided map.
   */
  static _fromMap(snapData) {
    snapData.options = snapData.options
      ? snapData.options.map(option => Option.fromMap(option))
      : [];
    snapData.allergens = snapData.allergens
      ? snapData.allergens.map(allergen => Allergen.fromMap(allergen))
      : [];
    return new Restaurant(snapData);
  }

  /**
   * @returns {string} A `string` representation of the collection to which this
   * `Restaurant` belongs to.
   */
  get _functionUrl() {
    return "restaurants";
  }

  get _collectionName() {
    return `restaurants`;
  }

  get _entityName() {
    return "restaurant";
  }
}

export default Restaurant;
